import { c as _c } from "react/compiler-runtime";
/* eslint-disable local-rules/require-use-client */
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { cn } from '@src/utils/tailwind';
import type { SKUDropdownOption } from './SKUSelectorProps';
export interface SKUSelectorDropdownProps {
  dropdownOptions: SKUDropdownOption[] | undefined;
  activeOption: SKUDropdownOption | undefined;
  selectedSku: string;
  isLoading: boolean;
  onChange: (sku: string) => void;
}
export function SKUSelectorDropdown(t0) {
  const $ = _c(15);
  const {
    dropdownOptions,
    activeOption,
    selectedSku,
    isLoading,
    onChange
  } = t0;
  const t1 = activeOption?.label;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronUpDownIcon className="size-4" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <ListboxButton className="flex items-center justify-between rounded-lg p-4 text-left outline outline-1 outline-bodi-gray-butters">{t1}{t2}</ListboxButton>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("mt-2 w-(--button-width) origin-top rounded-lg bg-bodi-white py-2 outline outline-1 outline-bodi-gray-butters drop-shadow-md", "transition duration-200 ease-out data-closed:scale-95 data-closed:opacity-0");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== dropdownOptions || $[5] !== selectedSku) {
    t5 = dropdownOptions?.map(option => <ListboxOption key={option.sku} value={option.sku} className="flex items-center gap-2 p-3 text-left hover:bg-bodi-accent-bright-300"><CheckIcon className={cn("size-5 text-transparent", option.sku === selectedSku && "text-bodi-accent-deep-500")} />{option.label}</ListboxOption>);
    $[4] = dropdownOptions;
    $[5] = selectedSku;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <ListboxOptions anchor="bottom" transition={true} className={t4}>{t5}</ListboxOptions>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isLoading || $[10] !== onChange || $[11] !== selectedSku || $[12] !== t3 || $[13] !== t6) {
    t7 = <Listbox value={selectedSku} onChange={onChange} disabled={isLoading}>{t3}{t6}</Listbox>;
    $[9] = isLoading;
    $[10] = onChange;
    $[11] = selectedSku;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}